import React, { useMemo, useState } from "react";

const StudentAvatar = ({
  size = { base: 36, sm: 44 },
  nameKey = "studentName",
  avatarKey = "avatarurl",
  className = "",
  textSize = { base: "0.875rem", sm: "1rem" }
}) => {
  const studentName = localStorage.getItem(nameKey) || "";
  const avatarUrl = localStorage.getItem(avatarKey) || "";

  const isSmallUp =
    typeof window !== "undefined"
      ? window.matchMedia("(min-width: 640px)").matches
      : true;

  const finalSize = typeof size === "number" ? size : isSmallUp ? size.sm : size.base;
  const finalTextSize =
    typeof textSize === "string" ? textSize : isSmallUp ? textSize.sm : textSize.base;

  const initials = useMemo(() => {
    const parts = studentName.trim().split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] || "";
    const second = parts[1]?.[0] || parts[0]?.[1] || "";
    return `${first}${second}`.toUpperCase();
  }, [studentName]);

  const [imgError, setImgError] = useState(false);

  const shouldShowImage = !!avatarUrl && !imgError;

  if (shouldShowImage) {
    return (
      <img
        src={avatarUrl}
        alt={studentName || "Student"}
        width={finalSize}
        height={finalSize}
        onError={() => setImgError(true)}
        className={`rounded-full object-cover border-2 border-blue-100 bg-blue-50 ${className}`}
        style={{ width: finalSize, height: finalSize }}
      />
    );
  }

  return (
    <div
      className={`bg-blue-50 border-2 border-blue-100 rounded-full flex items-center justify-center ${className}`}
      style={{ width: finalSize, height: finalSize }}
      aria-label={studentName || "Student"}
      title={studentName || ""}
    >
      <span className="text-blue-600 font-semibold" style={{ fontSize: finalTextSize, lineHeight: 1 }}>
        {initials || "?"}
      </span>
    </div>
  );
};

export default StudentAvatar;
